export const SECTION_POSITION = "1.1";
export const SECTION_WORK_FORMAT = "1.3";
export const SECTION_WORK_SCHEDULE = "4.1";
export const SECTION_SALARY = "4.12";

export type StructuredClauseSection =
  | typeof SECTION_POSITION
  | typeof SECTION_WORK_SCHEDULE
  | typeof SECTION_SALARY;

export const MANAGER_DISABLED_AMENDMENT_TYPES = ["workSchedule"] as const;
